import ToggleSwitch from "Common/ToggleSwitch";
import { useEffect, useState } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { authServices } from "Utils/auth/services";

interface MarketPositionModalProps {
  show: any;
  clickHandler: any;
  marketIds: string;
  marketName: string;
}

interface Total {
  selection_id: number;
  selection_name: string;
  win_loss: number;
}
const MarketPositionModal = ({
  show,
  clickHandler,
  marketIds,
  marketName,
}: MarketPositionModalProps) => {
  const [showMarket, setMarket] = useState(true);
  const [showBack, setBack] = useState(false);

  const toggleMarket = () => {
    setMarket(!showMarket);
  };

  // const [showOn, setShowOn] = useState(false);
  const [bookData, setBookData] = useState<any>();
  const [BookFancyData, setBookFancyData] = useState<any>();

  const [userData, setUserData] = useState<string>("");
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    if (userId) {
      setUserData(userId);
    }
    // eslint-disable-next-line
  }, [userId, show]);

  const getMarketPosition = async () => {
    const { response } = await authServices.getMarketPosition({
      user_id: userData || "",
      market_id: marketIds,
    });
    if (response) {
      if (response?.data) {
        setBookData(response);
      }
    }
  };

  useEffect(() => {
    if (marketIds) {
      getMarketPosition();
    }
    // eslint-disable-next-line
  }, [userData, marketIds]);

  const normalizeTeamName = (team: string): string => {
    return team.toLowerCase().replace(/ /g, "_");
  };

  // useEffect(() => {
  //   if (!bookData?.data) return;
  //   const mergedData = bookData.data.users.map((user: any) => {
  //     const mergedUser = { ...user };

  //     bookData.data.metadata.teams.forEach((team: string) => {
  //       const normalizedTeam = normalizeTeamName(team);
  //       const teamScore = user[normalizedTeam];
  //       const teamExposure = user[`${normalizedTeam}_total_exposure`];
  //       mergedUser[team] = {
  //         win_loss: teamScore || 0,
  //         total_exposure: teamExposure || 0,
  //       };

  //       delete mergedUser[normalizedTeam];
  //       delete mergedUser[`${normalizedTeam}_total_exposure`];
  //     });

  //     return mergedUser;
  //   });

  //   setBookFancyData(mergedData);
  //    // eslint-disable-next-line
  // }, [bookData]);

  useEffect(() => {
    if (!bookData?.data) return;

    const { users, metadata } = bookData.data;
    const exposures = bookData.data.metadata.total_exposure;

    const groupedByPriority: { [priority: number]: any } = {};

    exposures.forEach((exposureItem: any) => {
      const { selection_name, sort_priority } = exposureItem;
      const normalizedTeam = normalizeTeamName(selection_name);

      const teamUsers = users.map((user: any) => ({
        user_id: user.user_id,
        user_name: user.user_name,
        user_type_id: user.user_type_id,
        domain_name: user.domain_name,
        win_loss: user[normalizedTeam] || 0,
        total_exposure: user[`${normalizedTeam}_total_exposure`] || 0,
      }));

      groupedByPriority[sort_priority] = {
        sort_priority,
        selection_name,
        users: teamUsers,
        parent: metadata?.parent,
      };
    });

    const sortedData = Object.values(groupedByPriority).sort(
      (a: any, b: any) => a.sort_priority - b.sort_priority
    );

    setBookFancyData(sortedData);
  }, [bookData]);

  const handleParentShere = (ids: string | null | undefined) => {
    if (ids) {
      setUserData(ids);
    }
  };

  const getWinLossByTeam = (team: string, dataArray: Total[]): number => {
    const teamData = dataArray.find((item) => item.selection_name === team);
    return teamData ? teamData.win_loss : 0;
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={clickHandler}
      className="zoomIn"
      scrollable
    >
      <Modal.Header className="modal-title fw-bold d-flex justify-content-between pb-1">
        <div>
          <i
            className="ri-arrow-left-line me-2 cursor-pointer"
            onClick={() => handleParentShere(bookData?.parent_id)}
          ></i>{" "}
          Market Position:{" "}
          <span className="text-muted fw-normal">({marketName})</span>
        </div>
        <Button variant="light btn-sm" onClick={clickHandler}>
          <i className="ri-close-line fs-xl align-middle"></i>
        </Button>
      </Modal.Header>
      <Modal.Body className="fs-md">
        <div className="d-flex align-items-center">
          {showBack ? (
            <span
              onClick={() => setBack(false)}
              className="fs-lg ri-arrow-left-line me-2 cursor-pointer"
            ></span>
          ) : null}
          <strong className="me-3">
            Position of {BookFancyData && BookFancyData[0]?.domain_name}
          </strong>
          <ToggleSwitch
            On="S"
            Off="F"
            onChange={toggleMarket}
            checked={showMarket ? true : false}
          />
        </div>
        <div className="table-responsive">
          <Table className="align-middle table-striped table-nowrap mb-0">
            <thead>
              <tr>
                <th scope="col">Domain Name</th>
                <th scope="col">Account</th>
                {BookFancyData?.map((team: any, i: number) => (
                  <th key={i}>{team.selection_name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {BookFancyData &&
                BookFancyData[0]?.users?.map((user: any, id: number) => {
                  return (
                    <tr key={id}>
                      <td>{user?.domain_name}</td>
                      <td
                        className="cursor-pointer"
                        onClick={() => handleParentShere(user?.user_id)}
                      >
                        <Button
                          variant="subtle-primary"
                          className="rounded-pill p-1"
                          style={{ width: "30px" }}
                        >
                          {user?.user_type_id == "1" ? "C" : "A"}
                        </Button>
                        <span className="text-primary ms-2">
                          {user?.user_name}
                        </span>
                      </td>

                      {BookFancyData?.map((team: any, index: number) => {
                        const userData = team.users.find(
                          (u: any) => u.user_id === user.user_id
                        );
                        const value = showMarket
                          ? userData?.win_loss
                          : userData?.total_exposure;
                        return (
                          <td
                            key={index}
                            className={
                              value < 0 ? "text-danger" : "text-success"
                            }
                          >
                            {value?.toFixed(2)}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}

              {showMarket ? (
                <tr>
                  <td></td>
                  <td className="fw-bold">Total</td>
                  {BookFancyData?.map((team: any, index: number) => {
                    // const totalWinLoss = getWinLossByTeam(
                    //   team,
                    //   bookData.data.metadata.total
                    // );
                    const teamName = team.selection_name;
                    const totalWinLoss = getWinLossByTeam(
                      teamName,
                      bookData?.data?.metadata.total || []
                    );

                    return (
                      <td
                        key={index}
                        className={
                          totalWinLoss < 0 ? "text-danger" : "text-success"
                        }
                      >
                        {totalWinLoss?.toFixed(2)}
                      </td>
                    );
                  })}
                </tr>
              ) : (
                <tr>
                  <td></td>
                  <td className="fw-bold">Total</td>
                  {BookFancyData?.map((team: any, index: number) => {
                    const totalExposure = team.users.reduce(
                      (acc: number, u: any) => acc + u.total_exposure,
                      0
                    );

                    return (
                      <td
                        key={index}
                        className={
                          totalExposure < 0 ? "text-danger" : "text-success"
                        }
                      >
                        {totalExposure && totalExposure?.toFixed(2)}
                      </td>
                    );
                  })}
                </tr>
              )}
              {showMarket && (
                <tr>
                  <td></td>
                  <td className="fw-bold">Own</td>
                  {BookFancyData?.map((team: any, index: number) => {
                    const ownWinLoss = getWinLossByTeam(
                      team.selection_name,
                      bookData?.data?.metadata.own || []
                    );
                    return (
                      <td
                        key={index}
                        className={
                          ownWinLoss < 0 ? "text-danger" : "text-success"
                        }
                      >
                        {Number(ownWinLoss).toFixed(2)}
                      </td>
                    );
                  })}
                </tr>
              )}

              {showMarket && bookData?.data?.metadata.parent?.length > 0 && (
                <tr>
                  <td></td>
                  <td className="fw-bold">Parent</td>
                  {BookFancyData?.map((team: any, index: any) => {
                    const ownWinLoss = getWinLossByTeam(
                      team.selection_name,
                      bookData?.data?.metadata.parent || []
                    );
                    return (
                      <td
                        key={index}
                        className={
                          ownWinLoss < 0 ? "text-danger" : "text-success"
                        }
                      >
                        {ownWinLoss?.toFixed(2) || 0}
                      </td>
                    );
                  })}
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MarketPositionModal;
